module.exports = __webpack_public_path__ + "img/bg.45300920.jpg";